import React from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { IoReturnDownBack } from 'react-icons/io5'
import { Rate } from 'antd'
import { Back, Container, ResponseContainer } from './Style'
import { Col, Empty, Row, Spin } from 'antd'
import { FcApproval } from 'react-icons/fc'
import { Content, RateStar } from '../../globalComponents/PostCard'
import { FaRegCommentAlt } from 'react-icons/fa'
import { IDAvatar, Rating, SubmitButton, UserImage } from '../Services/Styles'
import { useAppSelector } from '../../app/hooks'
import { StyledInput } from '../Post/style'
import { useLazyQuery, useMutation } from '@apollo/client'
import {
  ANSWER_QUESTION,
  FETCH_SINGLE_QUESTION,
  RATE_ANSWER,
  REPLY_ANSWER,
} from '../../app/apollo'
import { NotificationAlert } from '../../utils/NotificationAlert'
import { Text } from '../Education/style'
import { durationFinder } from '../../utils/DurationFormatter'

const Details = () => {
  const history = useHistory()
  const location: any = useLocation()
  const [loading, setLoading] = React.useState(true)
  const [comment, setComment] = React.useState('')
  const [data, setData] = React.useState(null) as any
  const [value, setValue] = React.useState(0)
  const [error, setError] = React.useState(null) as any
  const [answer, setAnswer] = React.useState('')
  const [loadingAnswer, setLoadingAnswer] = React.useState(false)
  const [loadingComment, setLoadingComment] = React.useState(false)
  const userState = useAppSelector((state) => state?.userInfoReducer?.content)
  console.log('user', userState)
  const [getQuestionById, getQuestionIdData] = useLazyQuery(
    FETCH_SINGLE_QUESTION,
  )
  const [rateAnswer] = useMutation(RATE_ANSWER)
  const desc = ['terrible', 'bad', 'normal', 'good', 'wonderful']

  const [answerQuestion] = useMutation(ANSWER_QUESTION)
  const [commentOnAnswer] = useMutation(REPLY_ANSWER)
  const handleReplyAnswer = async (id: number, content: String) => {
    if (content.length > 0) {
      setLoadingComment(true)

      try {
        const response = await commentOnAnswer({
          variables: {
            answer_id: id,
            answer: content.trim(),
          },
        })
        if (response) {
          setLoadingComment(false)
          if (response?.data?.commentOnAnswer?.success) {
            NotificationAlert('success', 'Reply Posted Successfully')
            fetchDetails()
          } else {
            NotificationAlert('error', 'Answer Not Posted')
          }
        }
      } catch (e) {
        console.log('reply answer error', e)
        setLoadingComment(false)
      }
    }
  }
  const handleAnswerQuestion = async (id: number, content: String) => {
    if (content.length > 0) {
      setLoadingAnswer(true)

      try {
        const response = await answerQuestion({
          variables: {
            question_id: id,
            answer: content.trim(),
          },
        })
        if (response) {
          setLoadingAnswer(false)
          if (response?.data?.answerQuestion?.success) {
            NotificationAlert('success', 'Answer Posted Successfully')
            fetchDetails()
            setAnswer('')
          } else {
            NotificationAlert('error', 'Answer Not Posted')
          }
        }
      } catch (e) {
        console.log('answer question error', e)
        setLoadingAnswer(false)
      }
    }
  }
  const handleChange = async (value: any, id: any) => {
    setValue(value)
    try {
      const reasponse = await rateAnswer({
        variables: {
          answer_id: id,
          rating: value,
        },
      })
      if (reasponse?.data?.rateAnswer?.success) {
        NotificationAlert('success', 'rated successfully')
      }
    } catch (e) {
      console.log('error', e)
    }
  }
  const response = data?.question?.answers?.map((res: any) => {
    return (
      <>
        <ResponseContainer>
          <div>
            <img src={res?.user?.photolink} alt={res?.user?.firstname} />
            <div style={{ width: '100%', marginLeft: '10px' }}>
              <div
                style={{ width: '100%', display: 'flex', alignItems: 'center' }}
              >
                <h1>
                  {res?.user?.firstname} {res?.user?.lastname}{' '}
                  <span>{res?.rank ? res?.rank : 'STARTER'}</span>
                  {userState?.id !== res?.user?.id && res?.rating < 1 && (
                    <span style={{ marginLeft: '5px' }}>
                      <Rate
                        tooltips={desc}
                        onChange={(e) => handleChange(e, res?.id)}
                        value={value}
                      />
                    </span>
                  )}
                </h1>
                <h5>{durationFinder(res?.created_at)} ago</h5>
              </div>
              <p>{res?.answer}</p>
              {res?.comments &&
                res?.comments?.map((rep: any) => {
                  return (
                    <ResponseContainer>
                      <div>
                        <img src={rep?.user?.photolink} alt={rep?.name} />
                        <div style={{ width: '100%', marginLeft: '10px' }}>
                          <div
                            style={{
                              width: '100%',
                              display: 'flex',
                              alignItems: 'center',
                            }}
                          >
                            <h1>
                              {rep?.user?.firstname} {rep.user?.lastname}{' '}
                              {/* <span>{rep?.rank ? rep?.rank : 'STARTER'}</span> */}
                            </h1>
                            <h5>{durationFinder(rep?.created_at)} ago</h5>
                          </div>
                          <p style={{ fontWeight: 400 }}>{rep?.comment}</p>
                        </div>
                      </div>
                    </ResponseContainer>
                  )
                })}
              <div
                style={{ display: 'block', width: '100%', marginTop: '10px' }}
              >
                <StyledInput
                  onChange={(e) => {
                    setComment(e.target.value)
                  }}
                  //   onKeyDown={(e) => {
                  //     e.keyCode === 13 &&
                  //       handleMakeComment(comment, +location?.state?.service?.id);
                  //   }}
                  placeholder="Type your reply here..."
                  autoSize={{ minRows: 2, maxRows: 3 }}
                />

                {loadingComment ? (
                  <>loading</>
                ) : (
                  <SubmitButton
                    onClick={() => {
                      handleReplyAnswer(res?.id, comment)
                      console.log()
                    }}
                  >
                    comment
                  </SubmitButton>
                )}
              </div>
            </div>
          </div>
        </ResponseContainer>
        <br />
      </>
    )
  })
  React.useEffect(() => {
    if (!location?.state?.id) {
      history.push('/home')
    } else {
      fetchDetails()
    }
  }, [])
  React.useEffect(() => {
    console.log('response ', getQuestionIdData)
    if (getQuestionIdData?.error) {
      NotificationAlert(
        'error',
        'Error occrured',
        'Could not fetch the details',
      )
      setError(true)
      setLoading(false)
    } else if (getQuestionIdData?.data?.getQuestionById) {
      setLoading(false)
      setError('')
      setData(getQuestionIdData?.data?.getQuestionById)
    } else if (getQuestionIdData?.loading) {
      setLoading(true)
      setError('')
    }
  }, [getQuestionIdData])

  const fetchDetails = async () => {
    setLoading(true)

    try {
      await getQuestionById({
        variables: {
          question_id: location?.state?.id,
        },
      })
    } catch (e) {
      console.log(e)
      setLoading(false)
    }
  }

  console.log('use location log', data)

  return (
    <>
      {loading && <Text>loading... please wait</Text>}
      {error && <Text>Error occurred, kindly relaod</Text>}
      {data && (
        <Container>
          <Back onClick={() => history.goBack()}>
            <IoReturnDownBack />
            <h2>back</h2>
          </Back>
          <br />
          <br />
          <Row style={{ width: '100%' }}>
            <Col
              xs={{ span: 24 }}
              md={{ span: 16 }}
              style={{ display: 'flex' }}
            >
              <RateStar
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                }}
              >
                <FcApproval style={{ margin: '0', fontSize: '30px' }} />
                <h3>{data?.question?.totalvalidanswers}</h3>
              </RateStar>
              <Content>
                <div>
                  <h1>{data?.question?.title || 'NULL'}</h1>
                  <p>{data?.question?.description || 'NULL'}</p>
                </div>
                <div>
                  <img
                    src={
                      data?.question?.user?.photolink ||
                      `https://images.unsplash.com/photo-1554151228-14d9def656e4?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=986&q=80`
                    }
                    alt={`New name`}
                  />
                  <p>
                    posted by:{' '}
                    <span>
                      {data?.question?.user?.firstname || 'null'}{' '}
                      {data?.question?.user?.lastname || 'null'}
                    </span>
                  </p>
                  <p style={{ marginLeft: '15px' }}>
                    {durationFinder(data?.question?.created_at)} ago
                  </p>
                  <p
                    title="comments"
                    style={{
                      marginLeft: 'auto',
                      alignItems: 'center',
                      display: 'flex',
                    }}
                  >
                    <FaRegCommentAlt style={{ marginRight: '4px' }} />
                    {data?.question?.answers?.length}
                  </p>
                </div>
              </Content>
            </Col>
          </Row>
          <br />
          <Row style={{ width: '95%', marginLeft: 'auto' }}>
            <Col xs={{ span: 24 }} md={{ span: 16 }}>
              <div style={{ display: 'block', width: '100%' }}>
                <StyledInput
                  value={answer}
                  onChange={(e) => {
                    setAnswer(e.target.value)
                  }}
                  //   onKeyDown={(e) => {
                  //     e.keyCode === 13 &&
                  //       handleMakeComment(comment, +location?.state?.service?.id);
                  //   }}
                  placeholder="Type your reply here..."
                  autoSize={{ minRows: 2, maxRows: 3 }}
                />
                {loadingAnswer ? (
                  <Spin />
                ) : (
                  <SubmitButton
                    onClick={() => {
                      handleAnswerQuestion(location?.state?.id, answer)
                      console.log()
                    }}
                  >
                    Submit answer
                  </SubmitButton>
                )}
              </div>
              <br />
              <hr />
              <br />
              {data?.question?.answers?.length > 0 && response}
              {data?.question?.answers?.length < 1 && <Empty />}
            </Col>
          </Row>
        </Container>
      )}
    </>
  )
}

export default Details
